// extracted by mini-css-extract-plugin
export default {"footerInfo":"FooterInfo_footerInfo__ZgdDO","title":"FooterInfo_title__bWglr","link":"FooterInfo_link__puY-p"};